// components/layoutHeader.tsx
'use client';

import Link from 'next/link';
import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';

export default function PublicHeader() {
     const { user } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* 로고 */}
          <Link href="/" className="flex items-center space-x-2">
            <div className="text-2xl font-bold text-green-600">🌱</div>
            <span className="text-xl font-bold text-gray-900">WHIHPLUS IFMS</span>
            <span className="text-sm text-gray-500 hidden sm:inline">
              Intelligent Farm Management System
            </span>
          </Link>

          {/* 데스크톱 메뉴 */}
          <nav className="hidden md:flex items-center space-x-8">

            <Link
              href="/intro"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors"
            >
              IFMS 소개
            </Link>
            <Link
              href="/features"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors"
            >
              특징
            </Link>
                        <Link
              href="/how-to"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors"
            >
              알아보기
            </Link>
            <Link
              href="/data"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors"
            >
              정보수집
            </Link>
            <Link
              href="/onboarding"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors"
            >
              시작하기
            </Link>

            <Link
              href="/demo"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors"
            >
              데모
            </Link>
            <Link
              href="/lab"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors"
            >
              Lab
            </Link>
            <div className="flex items-center space-x-3 ml-4 pl-4 border-l border-gray-300">
              <Link
                href="/login"
                className="text-gray-700 hover:text-green-600 font-medium transition-colors"
              >
                로그인
              </Link>
              <Link
                href="/signup"
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
              >
                회원가입
              </Link>
            </div>
          </nav>

          {/* 모바일 메뉴 버튼 */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="메뉴"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* 모바일 메뉴 */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-3">
              <Link
                href="/intro"
                className="px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-lg transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                IFMS 소개
              </Link>
              <Link
                href="/features"
                className="px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-lg transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                특징
              </Link>
              <Link
                href="/demo"
                className="px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-lg transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                데모
              </Link>
              <Link
                href="/lab"
                className="px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-lg transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Lab
              </Link>
              <div className="pt-3 mt-3 border-t border-gray-200 flex flex-col space-y-2">
                <Link
                  href="/auth/login"
                  className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  로그인
                </Link>
                <Link
                  href="/auth/signup"
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  회원가입
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
